import React from 'react';
import { AgentData_V10 } from '@dopomogai/types';

interface FooterSectionProps {
  agentData: AgentData_V10;
}

export const FooterSection: React.FC<FooterSectionProps> = ({
  agentData,
}) => {
  const { platformLinks, copyrightYear } = agentData;
  
  return (
    <footer className="text-center py-6 text-sm text-gray-500">
      <div className="flex justify-center space-x-4 mb-2">
        <a 
          href={platformLinks.termsOfServiceUrl}
          className="hover:text-gray-700"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>
        <a 
          href={platformLinks.privacyPolicyUrl}
          className="hover:text-gray-700"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        <a 
          href={platformLinks.contactUsUrl}
          className="hover:text-gray-700"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </a>
        <a 
          href={platformLinks.platformSocialImpactPageUrl}
          className="hover:text-gray-700"
          target="_blank"
          rel="noopener noreferrer"
        >
          Social Impact
        </a>
      </div>
      <p>© {copyrightYear} Dopomogai. All rights reserved.</p>
    </footer>
  );
};

